import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { GET_ALL_SPECIALTY } from "../../../api-setup/api-endpoints";

export const fetchSpecialtyData = async (cookiesData, dispatch) => {
  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_sort_number: 1,
      in_sort_order: "ASC",
      in_page_row_offset: 0,
    };

    const response = await POSTAPI(false, GET_ALL_SPECIALTY, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      const rawData = response.data.row_result;

      const transformedData = rawData.map((specialty) => ({
        id: specialty.specialty_mstr_key,
        text: specialty.specialty_name,
      }));

      return {
        success: true,
        specialtyData: transformedData,
        rawData: rawData,
      };
    } else {
      console.error("Failed to fetch specialty data:", response?.message || "Invalid response structure");
      return {
        success: false,
        specialtyData: [],
        rawData: [],
        error: response?.message || "Invalid response structure",
      };
    }
  } catch (error) {
    console.error("Error fetching specialty data:", error);
    return {
      success: false,
      specialtyData: [],
      rawData: [],
      error: error.message,
    };
  }
};
